import React from "react";
import { Link } from "react-router-dom";
import FontAwesome from "react-fontawesome";
const Carcard = ({ lastBookElementRef, list, snackMessage, handleOnClick }) => {
  // console.log(list);

  return (
    <>
      {list &&
        list.map((item, index) => {
          if (list.length === index + 1) {
            return (
              <div
                className="container-fluid"
                key={item.no}
                ref={lastBookElementRef}
              >
                <div className="row ">
                  <div className="col mb-2">
                    <div className="card  ">
                      <div className="row d-flex align-items-center ms-1 ">
                        <div className="col-lg-4">
                          <div className="row">
                            <div className="col-auto">
                              <span className="text-dark">{item.no}</span>
                            </div>

                            <div className="col-auto  text-center">
                              <h5>
                                <span className="badge rounded-pill bg-primary  ">
                                  {item.parkname}
                                </span>
                              </h5>
                            </div>

                            <div className="col-auto ">
                              {item.workstatus == "Resigned" ||
                              item.workstatus == "Resign" ? (
                                <strong
                                  className="card-title d-inline "
                                  style={{ fontSize: 16 }}
                                >
                                  <span
                                    className="badge bg-danger border-0 "
                                    style={{ fontSize: 16 }}
                                  >
                                    {item.fname} {item.lname} {"(ลาออก)"}
                                  </span>
                                </strong>
                              ) : (
                                <strong
                                  className="card-title d-inline me-2"
                                  style={{ fontSize: 16 }}
                                >
                                  {item.fname} {item.lname}
                                </strong>
                              )}
                            </div>
                            <div className="col-auto">
                              <i className="bi bi-telephone-fill text-primary" />
                              <span> {item.phone} </span>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-8 ">
                          <div className="row  mt-2  d-flex justify-content-end">
                            <div className="col-auto mx-1 ">
                              {item.jan === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0"
                                    onClick={() => handleOnClick(item.id, 1)}
                                  >
                                    <span className="my-2 fs-6">01</span>
                                  </button>
                                </h6>
                              ) : item.jan === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 1, 1)}
                                  >
                                    <span className="my-2 fs-6">01</span>
                                  </button>
                                </h6>
                              ) : item.jan === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 1)}
                                  >
                                    <span className="my-2 fs-6">01</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 1)}
                                  >
                                    <span className="my-2 fs-6">01</span>
                                  </button>
                                </h6>
                              )}
                            </div>

                            <div className="col-auto mx-1 text-center p-0">
                              {item.feb === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 2)}
                                  >
                                    <span className="my-2 fs-6">02</span>
                                  </button>
                                </h6>
                              ) : item.feb === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 2, 1)}
                                  >
                                    <span className="my-2 fs-6">02</span>
                                  </button>
                                </h6>
                              ) : item.feb === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 2)}
                                  >
                                    <span className="my-2 fs-6">02</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 2)}
                                  >
                                    <span className="my-2 fs-6">02</span>
                                  </button>
                                </h6>
                              )}
                            </div>
                            <div className="col-auto mx-1 text-center p-0">
                              {item.mar === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 3)}
                                  >
                                    <span className="my-2 fs-6">03</span>
                                  </button>
                                </h6>
                              ) : item.mar === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 3, 1)}
                                  >
                                    <span className="my-2 fs-6">03</span>
                                  </button>
                                </h6>
                              ) : item.mar === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 3)}
                                  >
                                    <span className="my-2 fs-6">03</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 3)}
                                  >
                                    <span className="my-2 fs-6">03</span>
                                  </button>
                                </h6>
                              )}
                            </div>
                            <div className="col-auto mx-1 text-center p-0">
                              {item.apr === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 4)}
                                  >
                                    <span className="my-2 fs-6">04</span>
                                  </button>
                                </h6>
                              ) : item.apr === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 4, 1)}
                                  >
                                    <span className="my-2 fs-6">04</span>
                                  </button>
                                </h6>
                              ) : item.apr === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 4)}
                                  >
                                    <span className="my-2 fs-6">04</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 4)}
                                  >
                                    <span className="my-2 fs-6">04</span>
                                  </button>
                                </h6>
                              )}
                            </div>
                            <div className="col-auto mx-1 text-center p-0">
                              {item.may === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 5)}
                                  >
                                    <span className="my-2 fs-6">05</span>
                                  </button>
                                </h6>
                              ) : item.may === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 5, 1)}
                                  >
                                    <span className="my-2 fs-6">05</span>
                                  </button>
                                </h6>
                              ) : item.may === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 5)}
                                  >
                                    <span className="my-2 fs-6">05</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 5)}
                                  >
                                    <span className="my-2 fs-6">05</span>
                                  </button>
                                </h6>
                              )}
                            </div>
                            <div className="col-auto mx-1 text-center p-0">
                              {item.jun === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 6)}
                                  >
                                    <span className="my-2 fs-6">06</span>
                                  </button>
                                </h6>
                              ) : item.jun === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 6, 1)}
                                  >
                                    <span className="my-2 fs-6">06</span>
                                  </button>
                                </h6>
                              ) : item.jun === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 6)}
                                  >
                                    <span className="my-2 fs-6">06</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 6)}
                                  >
                                    <span className="my-2 fs-6">06</span>
                                  </button>
                                </h6>
                              )}
                            </div>
                            <div className="col-auto mx-1 text-center p-0">
                              {item.jul === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 7)}
                                  >
                                    <span className="my-2 fs-6">07</span>
                                  </button>
                                </h6>
                              ) : item.jul === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 7, 1)}
                                  >
                                    <span className="my-2 fs-6">07</span>
                                  </button>
                                </h6>
                              ) : item.jul === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 7)}
                                  >
                                    <span className="my-2 fs-6">07</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 7)}
                                  >
                                    <span className="my-2 fs-6">07</span>
                                  </button>
                                </h6>
                              )}
                            </div>
                            <div className="col-auto mx-1 text-center p-0">
                              {item.aug === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 8)}
                                  >
                                    <span className="my-2 fs-6">08</span>
                                  </button>
                                </h6>
                              ) : item.aug === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 8, 1)}
                                  >
                                    <span className="my-2 fs-6">08</span>
                                  </button>
                                </h6>
                              ) : item.aug === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 8)}
                                  >
                                    <span className="my-2 fs-6">08</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 8)}
                                  >
                                    <span className="my-2 fs-6">08</span>
                                  </button>
                                </h6>
                              )}
                            </div>
                            <div className="col-auto mx-1 text-center p-0">
                              {item.sep === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 9)}
                                  >
                                    <span className="my-2 fs-6">09</span>
                                  </button>
                                </h6>
                              ) : item.sep === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 9, 1)}
                                  >
                                    <span className="my-2 fs-6">09</span>
                                  </button>
                                </h6>
                              ) : item.sep === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 9)}
                                  >
                                    <span className="my-2 fs-6">09</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 9)}
                                  >
                                    <span className="my-2 fs-6">09</span>
                                  </button>
                                </h6>
                              )}
                            </div>
                            <div className="col-auto mx-1 text-center p-0">
                              {item.oct === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 10)}
                                  >
                                    <span className="my-2 fs-6">10</span>
                                  </button>
                                </h6>
                              ) : item.oct === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() =>
                                      handleOnClick(item.id, 10, 1)
                                    }
                                  >
                                    <span className="my-2 fs-6">10</span>
                                  </button>
                                </h6>
                              ) : item.oct === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 10)}
                                  >
                                    <span className="my-2 fs-6">10</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 10)}
                                  >
                                    <span className="my-2 fs-6">10</span>
                                  </button>
                                </h6>
                              )}
                            </div>
                            <div className="col-auto mx-1 text-center p-0">
                              {item.nov === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 11)}
                                  >
                                    <span className="my-2 fs-6">11</span>
                                  </button>
                                </h6>
                              ) : item.nov === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() =>
                                      handleOnClick(item.id, 11, 1)
                                    }
                                  >
                                    <span className="my-2 fs-6">11</span>
                                  </button>
                                </h6>
                              ) : item.nov === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 11)}
                                  >
                                    <span className="my-2 fs-6">11</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 11)}
                                  >
                                    <span className="my-2 fs-6">11</span>
                                  </button>
                                </h6>
                              )}
                            </div>

                            <div className="col-auto mx-1 text-center p-0">
                              {item.decem === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 12)}
                                  >
                                    <span className="my-2 fs-6">12</span>
                                  </button>
                                </h6>
                              ) : item.decem === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() =>
                                      handleOnClick(item.id, 12, 1)
                                    }
                                  >
                                    <span className="my-2 fs-6">12</span>
                                  </button>
                                </h6>
                              ) : item.decem === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 12)}
                                  >
                                    <span className="my-2 fs-6">12</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 12)}
                                  >
                                    <span className="my-2 fs-6">12</span>
                                  </button>
                                </h6>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          } else {
            return (
              <div className="container-fluid" key={item.no}>
                <div className="row ">
                  <div className="col mb-2">
                    <div className="card  ">
                      <div className="row d-flex align-items-center ms-1 ">
                        <div className="col-lg-4">
                          <div className="row">
                            <div className="col-auto">
                              <span className="text-dark">{item.no}</span>
                            </div>

                            <div className="col-auto  text-center">
                              <h5>
                                <span className="badge rounded-pill bg-primary  ">
                                  {item.parkname}
                                </span>
                              </h5>
                            </div>

                            <div className="col-auto ">
                              {item.workstatus == "Resigned" ||
                              item.workstatus == "Resign" ? (
                                <strong
                                  className="card-title d-inline "
                                  style={{ fontSize: 16 }}
                                >
                                  <span
                                    className="badge bg-danger border-0 "
                                    style={{ fontSize: 16 }}
                                  >
                                    {item.fname} {item.lname} {"(ลาออก)"}
                                  </span>
                                </strong>
                              ) : (
                                <strong
                                  className="card-title d-inline me-2"
                                  style={{ fontSize: 16 }}
                                >
                                  {item.fname} {item.lname}
                                </strong>
                              )}
                            </div>
                            <div className="col-auto">
                              <i className="bi bi-telephone-fill text-primary" />
                              <span> {item.phone} </span>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-8 ">
                          <div className="row  mt-2 d-flex justify-content-end me-2">
                            <div className="col-auto mx-1 p-0 ">
                              {item.jan === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 mt-1"
                                    onClick={() => handleOnClick(item.id, 1)}
                                  >
                                    <span className="my-2 fs-6">01</span>
                                  </button>
                                </h6>
                              ) : item.jan === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 1, 1)}
                                  >
                                    <span className="my-2 fs-6">01</span>
                                  </button>
                                </h6>
                              ) : item.jan === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 1)}
                                  >
                                    <span className="my-2 fs-6">01</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 1)}
                                  >
                                    <span className="my-2 fs-6">01</span>
                                  </button>
                                </h6>
                              )}
                            </div>

                            <div className="col-auto mx-1 text-center p-0 p-0">
                              {item.feb === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 2)}
                                  >
                                    <span className="my-2 fs-6">02</span>
                                  </button>
                                </h6>
                              ) : item.feb === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 2, 1)}
                                  >
                                    <span className="my-2 fs-6">02</span>
                                  </button>
                                </h6>
                              ) : item.feb === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 2)}
                                  >
                                    <span className="my-2 fs-6">02</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 2)}
                                  >
                                    <span className="my-2 fs-6">02</span>
                                  </button>
                                </h6>
                              )}
                            </div>
                            <div className="col-auto mx-1 text-center p-0">
                              {item.mar === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 3)}
                                  >
                                    <span className="my-2 fs-6">03</span>
                                  </button>
                                </h6>
                              ) : item.mar === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 3, 1)}
                                  >
                                    <span className="my-2 fs-6">03</span>
                                  </button>
                                </h6>
                              ) : item.mar === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 3)}
                                  >
                                    <span className="my-2 fs-6">03</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 3)}
                                  >
                                    <span className="my-2 fs-6">03</span>
                                  </button>
                                </h6>
                              )}
                            </div>
                            <div className="col-auto mx-1 text-center p-0">
                              {item.apr === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 4)}
                                  >
                                    <span className="my-2 fs-6">04</span>
                                  </button>
                                </h6>
                              ) : item.apr === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 4, 1)}
                                  >
                                    <span className="my-2 fs-6">04</span>
                                  </button>
                                </h6>
                              ) : item.apr === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 4)}
                                  >
                                    <span className="my-2 fs-6">04</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 4)}
                                  >
                                    <span className="my-2 fs-6">04</span>
                                  </button>
                                </h6>
                              )}
                            </div>
                            <div className="col-auto mx-1 text-center p-0">
                              {item.may === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 5)}
                                  >
                                    <span className="my-2 fs-6">05</span>
                                  </button>
                                </h6>
                              ) : item.may === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 5, 1)}
                                  >
                                    <span className="my-2 fs-6">05</span>
                                  </button>
                                </h6>
                              ) : item.may === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 5)}
                                  >
                                    <span className="my-2 fs-6">05</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 5)}
                                  >
                                    <span className="my-2 fs-6">05</span>
                                  </button>
                                </h6>
                              )}
                            </div>
                            <div className="col-auto mx-1 text-center p-0">
                              {item.jun === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 6)}
                                  >
                                    <span className="my-2 fs-6">06</span>
                                  </button>
                                </h6>
                              ) : item.jun === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 6, 1)}
                                  >
                                    <span className="my-2 fs-6">06</span>
                                  </button>
                                </h6>
                              ) : item.jun === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 6)}
                                  >
                                    <span className="my-2 fs-6">06</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 6)}
                                  >
                                    <span className="my-2 fs-6">06</span>
                                  </button>
                                </h6>
                              )}
                            </div>
                            <div className="col-auto mx-1 text-center p-0">
                              {item.jul === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 7)}
                                  >
                                    <span className="my-2 fs-6">07</span>
                                  </button>
                                </h6>
                              ) : item.jul === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 7, 1)}
                                  >
                                    <span className="my-2 fs-6">07</span>
                                  </button>
                                </h6>
                              ) : item.jul === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 7)}
                                  >
                                    <span className="my-2 fs-6">07</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 7)}
                                  >
                                    <span className="my-2 fs-6">07</span>
                                  </button>
                                </h6>
                              )}
                            </div>
                            <div className="col-auto mx-1 text-center p-0">
                              {item.aug === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 8)}
                                  >
                                    <span className="my-2 fs-6">08</span>
                                  </button>
                                </h6>
                              ) : item.aug === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 8, 1)}
                                  >
                                    <span className="my-2 fs-6">08</span>
                                  </button>
                                </h6>
                              ) : item.aug === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 8)}
                                  >
                                    <span className="my-2 fs-6">08</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 8)}
                                  >
                                    <span className="my-2 fs-6">08</span>
                                  </button>
                                </h6>
                              )}
                            </div>
                            <div className="col-auto mx-1 text-center p-0">
                              {item.sep === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 9)}
                                  >
                                    <span className="my-2 fs-6">09</span>
                                  </button>
                                </h6>
                              ) : item.sep === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 9, 1)}
                                  >
                                    <span className="my-2 fs-6">09</span>
                                  </button>
                                </h6>
                              ) : item.sep === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 9)}
                                  >
                                    <span className="my-2 fs-6">09</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 9)}
                                  >
                                    <span className="my-2 fs-6">09</span>
                                  </button>
                                </h6>
                              )}
                            </div>
                            <div className="col-auto mx-1 text-center p-0">
                              {item.oct === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 10)}
                                  >
                                    <span className="my-2 fs-6">10</span>
                                  </button>
                                </h6>
                              ) : item.oct === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() =>
                                      handleOnClick(item.id, 10, 1)
                                    }
                                  >
                                    <span className="my-2 fs-6">10</span>
                                  </button>
                                </h6>
                              ) : item.oct === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 10)}
                                  >
                                    <span className="my-2 fs-6">10</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 10)}
                                  >
                                    <span className="my-2 fs-6">10</span>
                                  </button>
                                </h6>
                              )}
                            </div>
                            <div className="col-auto mx-1 text-center p-0">
                              {item.nov === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 11)}
                                  >
                                    <span className="my-2 fs-6">11</span>
                                  </button>
                                </h6>
                              ) : item.nov === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() =>
                                      handleOnClick(item.id, 11, 1)
                                    }
                                  >
                                    <span className="my-2 fs-6">11</span>
                                  </button>
                                </h6>
                              ) : item.nov === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 11)}
                                  >
                                    <span className="my-2 fs-6">11</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 11)}
                                  >
                                    <span className="my-2 fs-6">11</span>
                                  </button>
                                </h6>
                              )}
                            </div>

                            <div className="col-auto mx-1 text-center p-0">
                              {item.decem === 1 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-success border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 12)}
                                  >
                                    <span className="my-2 fs-6">12</span>
                                  </button>
                                </h6>
                              ) : item.decem === 2 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-warning border-0 m-1"
                                    onClick={() =>
                                      handleOnClick(item.id, 12, 1)
                                    }
                                  >
                                    <span className="my-2 fs-6">12</span>
                                  </button>
                                </h6>
                              ) : item.decem === 3 ? (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-danger border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 12)}
                                  >
                                    <span className="my-2 fs-6">12</span>
                                  </button>
                                </h6>
                              ) : (
                                <h6>
                                  <button
                                    className="badge rounded-pill bg-secondary border-0 m-1"
                                    onClick={() => handleOnClick(item.id, 12)}
                                  >
                                    <span className="my-2 fs-6">12</span>
                                  </button>
                                </h6>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        })}
    </>
  );
};

export default Carcard;
